import { render, staticRenderFns } from "./AgentDisplay.vue?vue&type=template&id=2b20aa7a&scoped=true"
import script from "./AgentDisplay.vue?vue&type=script&lang=js"
export * from "./AgentDisplay.vue?vue&type=script&lang=js"
import style0 from "./AgentDisplay.vue?vue&type=style&index=0&id=2b20aa7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20aa7a",
  null
  
)

export default component.exports